import { AppConstants } from "../../../../app.constants";

export class PlaylistItemBorderSettings {
  public Id: number;
  public PlaylistItemId: number;
  public Color: string;
  public Size: number;

  constructor() {
    this.Color = AppConstants.MCL_BORDER_DEFAULT_BACKGROUND_COLOR;
    this.Size = AppConstants.MCL_BORDER_DISABLED_WIDTH;
  }
}
